module.exports = __webpack_public_path__ + "img/logo.166dc685.jpg";